import {
  SchoolModuleBatch,
  SchoolModuleEvent,
} from './../../models/module/moduledetails';
import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { asyncScheduler } from 'rxjs';
import { AdminAction } from 'src/app/models/adminaction.model';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { MeetingService } from 'src/app/services/meetings/meeting.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { SchoolmanagementService } from 'src/app/services/schoolmanagement.service';
import { UtilService } from 'src/app/services/util.service';
declare const $: any;

@Component({
  selector: 'app-view-events',
  templateUrl: './view-events.component.html',
  styleUrls: ['./view-events.component.scss'],
})
export class ViewEventsComponent implements OnInit {
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;
  //schId: any;
  moduleId = 0;
  isStudentView = true;
  module: any = {};
  schoolModuleEvent: Array<SchoolModuleEvent> = [];
  eventDetail = {
    eventName: '',
    start: new Date(),
    end: new Date(),
    body: '',
    venue: '',
    isLink: false,
    lessonTitle: '',
    moduleID:0,
    classId:0,
  };
  moduleBatches: SchoolModuleBatch[] = [];
  classid: number = 0;

  constructor(
    public headerinfo: ComponentheaderService,
    public schoolservice: SchoolmanagementService,
    public toastr: ToastrService,
    public util: UtilService,
    public moduleservice: ModulemanagementService,
    private activatedroute: ActivatedRoute,
    private modulemanager: ModulemanagementService,
    public classservice: ClassmanagementService,
    private meetingService:MeetingService

  ) {}
  async ngOnInit() {
    try {
      this.headerinfo.pageLoadingStarted(this);

      this.moduleId = this.activatedroute.snapshot.queryParams.moduleID;
      this.classid = this.activatedroute.snapshot.queryParams.classid;
      this.module = await this.moduleservice
        .getModuleDetails(this.moduleId)
        .toPromise();

      this.isStudentView = !this.module.isViewerAdmin;
      const adminActions: AdminAction[] = [];
      if (this.module.isViewerAdmin) {
        adminActions.push({
          displaytext: 'Add Event',
          route: '/events/add',
          params: { moduleID: this.moduleId ,classid:this.classid},
          classes: ['fas', 'fa-calendar'],
          disabled: !(await this.util.hasFeature(FeatureGroups.EVENTS)),
          featureGroup: FeatureGroups.EVENTS,
        });
      }
      this.headerinfo.setHeaderDisplay(
        'All Event',
        this.classid > 0
          ? [
              { displaytext: 'School', route: `/user/schoolhome` },
              {
                displaytext: 'Course',
                route: `/user/moduledetails`,
                params: { moduleID: this.moduleId },
              },
              {
                displaytext: 'Lesson',
                route: `/user/lesson`,
                params: { classid: this.classid },
              },
              {
                displaytext: 'Course Events',
                route: '/events/view',
                params: { moduleID: this.moduleId },
              },
            ]
          : [
              { displaytext: 'School', route: `/user/schoolhome` },
              {
                displaytext: 'Course',
                route: `/user/moduledetails`,
                params: { moduleID: this.moduleId },
              },
              {
                displaytext: 'Course Events',
                route: '/events/view',
                params: { moduleID: this.moduleId },
              },
            ],
        adminActions
      );

      if(!await this.util.hasFeature(FeatureGroups.EVENTS)){
        this.schoolModuleEvent = [];
      } else {
        this.moduleBatches = await this.moduleservice
          .getModuleBatches(this.moduleId)
          .toPromise();

        if (!this.isStudentView) {
          // const school: any = await this.schoolservice
          //   .getSchoolFromSubdomain()
          //   .toPromise();
          //this.schId = (await this.util.getStaticSchoolInfoBundle()).schoolInfo.id;
          this.schoolModuleEvent = await this.moduleservice
            .getModuleInvites(this.moduleId);
          this.moduleBatches = await this.moduleservice
          .getModuleBatches(this.moduleId).toPromise();

          if(this.module.allowBatches){
            this.schoolModuleEvent.forEach(m => {
              m.batchName = m.batchId === 0 ? "All Batches" : this.moduleBatches.find(b => b.id === m.batchId).name
            });
          }
        } else {
          this.schoolModuleEvent =
            await this.modulemanager.getUpcomingModuleInvites(
              this.moduleId,
              this.classid
            );
        }
      }

    } catch (error) {
      this.toastr.error(error);
    } finally {
      this.headerinfo.pageLoadingDone(this);
    }
  }

  isExpired(item: any) {
    if (new Date(item.inviteEndDate) > new Date()) {
      return false;
    }
    return true;
  }

  async cancelEvent(item: any) {
    await this.moduleservice
      .cancelModuleInviteMail(item)
      .toPromise()
      .then(() => {
        this.toastr.success('Event Cancelled');
        window.location.reload();
      });
  }

  popUpDetails(item: any){
    let url = item.venue;
    if(!url.startsWith('http') && this.util.isLink(url)){
      url = "https://"+url;
    }

    this.eventDetail.eventName = item.subject;
    this.eventDetail.start = item.inviteStartDate;
    this.eventDetail.end = item.inviteEndDate;
    this.eventDetail.body = item.body;
    this.eventDetail.venue = url;
    this.eventDetail.isLink = this.util.isLink(item.venue);
    this.eventDetail.lessonTitle = item.lessonTitle;

    $('#upcomingEventModal').modal('show');
  }

  async downloadAttendance(item:any){
    console.log(item);
    try {
      this.headerinfo.pageLoadingStarted(this);
    let data :any= await this.meetingService.getMeetingAttendance(item.meetingID).toPromise();
    const anchor = document.createElement('a');
    anchor.href = "data:application/octet-stream;base64,"+data.res.fileBytes;
    anchor.download=data.res.fileName;
    asyncScheduler
    anchor.click();
    } catch (error) {

    }finally{
      this.headerinfo.pageLoadingDone(this);
    }
  }

  canDownloadAttendance(venue:any){
    let org = window.location.origin+"/live?meetingid"
    if(venue.includes(org)){
      return true;
    }
    return false;
  }
}
